import React from 'react';
import { useNavigate } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Hata olduğunda state'i güncelle
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Hata loglama işlemi
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Hata olduğunda yönlendirme yap
      this.props.navigate("/something-went-wrong");
      return null; // Yönlendirme işlemi gerçekleştiği için UI render etmeye gerek yok
    }

    // Hata yoksa normal olarak children'ı render et
    return this.props.children; 
  }
}

// Functional wrapper to use navigate with class component
function ErrorBoundaryWrapper(props) {
  const navigate = useNavigate();
  return <ErrorBoundary {...props} navigate={navigate} />;
}

export default ErrorBoundaryWrapper;
